import { faLightbulb, faMoon } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { Container, Nav, Navbar } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { darkTheme, GlobalStyles, lightTheme } from '../../../globalStyle/theme';
import logo from '../../../images/icon/logo.svg';


const Header = () => {
    const [isDarkTheme, setIsDarkTheme] = useState(true);
    const location = useLocation();
    const path = location.pathname;
    return (
        <>
            <GlobalStyles theme={isDarkTheme ? darkTheme : lightTheme} />
            <Navbar expand="lg">
                <Container>
                    <Navbar.Brand href="#">
                        <img src={logo} alt="" />
                    </Navbar.Brand>
                    <Navbar.Toggle style={{ background: '#ff3465' }} aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="ms-auto text-end">
                            <Link className={`navbar-global-style ${path === '/home' ? 'nav-active-style' : ''}`} to='/home'>Home</Link>
                            <Link className={`navbar-global-style ${path === '/about' ? 'nav-active-style' : ''}`} to='/about'>About us</Link>
                            <Link className={`navbar-global-style ${path === '/offer' ? 'nav-active-style' : ''}`} to='/offer'>Offer</Link>
                            <Link className={`navbar-global-style ${path === '/events' ? 'nav-active-style' : ''}`} to='/events'>Events</Link>
                            <Link className={`navbar-global-style ${path === '/contact' ? 'nav-active-style' : ''}`} to='/contact'>Contact</Link>
                            <div>
                                <button
                                    onClick={() => setIsDarkTheme(!isDarkTheme)}
                                    className={`ms-2 btn rounded-pill ${isDarkTheme ? 'btn-light' : 'btn-dark'}`}>
                                    <FontAwesomeIcon icon={isDarkTheme ? faLightbulb : faMoon} />
                                </button>
                            </div>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </>
    );
};

export default Header;